import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.457,.543c.391,.391,.391,1.024,0,1.414L1.957,15.457c-.391,.391-1.024,.391-1.414,0-.391-.391-.391-1.024,0-1.414L14.043,.543c.391-.391,1.024-.391,1.414,0Z",
      "fill-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      d: "M.543,.543C.933,.152,1.567,.152,1.957,.543L15.457,14.043c.391,.391,.391,1.024,0,1.414s-1.024,.391-1.414,0L.543,1.957C.152,1.567,.152,.933,.543,.543Z",
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }